import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';

export const Conversation = (props) => {
    const { conversation } = props;
    const senderFirstName = conversation.creator && conversation.creator.first_name ? conversation.creator.first_name : '';
    const senderLastName = conversation.creator && conversation.creator.last_name ? conversation.creator.last_name : '';
    const participants = conversation.creator && conversation.creator.id ? conversation : null;

    if (!conversation || !participants) return null;

    if (participants) return (
        <Link to={`/networking/conversations/${conversation.id}`} style={{width: '100%'}}>
            <div id={conversation.id} className="col-xs-12">
                <div className="row">
                    <div>
                        <img className="img-circle message-img"
                            src="https://vignette2.wikia.nocookie.net/naginoasukara/images/8/86/Placeholder_person.png/revision/latest?cb=20130924151342"
                            alt="Member img" height="48" style={{margin: '5px 0'}}/>
                    </div>
                    {/* <div className="member-message-name col-xs-9"> */}
                        {
                            participants.length > 0 ?
                                (
                                    participants.map((participant) => {

                                        return (
                                            <h5 className="h5 msg-conversation-user margin-none">{participant.sender.first_name} {participant.sender.last_name}</h5>
                                        )

                                    })
                                )
                                :
                                (
                                    <h5 className="h5 msg-conversation-user margin-none">{senderFirstName} {senderLastName}</h5>
                                )
                        }
                    </div>
                <hr className="hr-tour margin-none" />
                </div>
            {/* </div> */}
        </Link>
    );
};

Conversation.propTypes = {
	conversation: PropTypes.object
}




// WEBPACK FOOTER //
// src/client/components/site/features/networking/pages/elements/Conversation.js